import type { DiagramSeriesGroup, DiagramSeriesOption } from '../types/DiagramSeries.types';

/**
 * The series the selector offers: only those with data in the current window, and only the groups
 * that still have one. Applied at display time on purpose — series colours are assigned from the
 * full, unfiltered list (see useDiagramSeriesColors), so a channel keeps its colour when another
 * channel has no data in a newly chosen window.
 */
export function getSelectableSeriesGroups(groups: DiagramSeriesGroup[]): DiagramSeriesGroup[] {
  return groups.flatMap((group) => {
    const series = group.series.filter((option) => option.hasData);

    return series.length > 0 ? [{ ...group, series }] : [];
  });
}

export function flattenDiagramSeriesGroups(groups: DiagramSeriesGroup[]): DiagramSeriesOption[] {
  return groups.flatMap((group) => group.series);
}

/** A remembered selection may name series the current target no longer has, or that have no data now. */
export function getValidSelectedSeriesIds(options: DiagramSeriesOption[], selectedSeriesIds: string[]): string[] {
  const enabledIds = new Set(options.filter((option) => option.hasData).map((option) => option.id));

  return selectedSeriesIds.filter((id) => enabledIds.has(id));
}
